"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewDetailButton = exports.AnalyticCardValueUnit = exports.AnalyticCardTrendLabel = exports.AnalyticCardPositiveTrendValue = exports.AnalyticCardNegativeTrendValue = exports.AnalyticCardTrendValue = exports.AnalyticCardTrend = exports.AnalyticCardTrendContainer = exports.AnalyticCardValue = exports.AnalyticCardTitle = exports.AnalyticCard = exports.AnalyticCardContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Icons_1 = require("../../components/Icons");
require("./AnalyticCard.css");
var ramda_1 = require("../../utils/ramda");
var classnames_1 = __importDefault(require("classnames"));
var Button_1 = require("../../components/Button");
var AnalyticCardContainer = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: (0, classnames_1.default)("vsx-analytic-card-container", className)
  }, restProps, {
    children: children
  }));
};
exports.AnalyticCardContainer = AnalyticCardContainer;
var AnalyticCard = function (_a) {
  var children = _a.children,
    className = _a.className,
    onClick = _a.onClick,
    restProps = __rest(_a, ["children", "className", "onClick"]);
  var isClickable = !(0, ramda_1.isNil)(onClick);
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: (0, classnames_1.default)("vsx-analytic-card", className, isClickable && "vsx-analytic-card-clickable"),
    onClick: onClick
  }, restProps, {
    children: children
  }));
};
exports.AnalyticCard = AnalyticCard;
var AnalyticCardTitle = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-analytic-card-title", className)
  }, {
    children: children
  }));
};
exports.AnalyticCardTitle = AnalyticCardTitle;
var AnalyticCardValue = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-analytic-card-value", className)
  }, {
    children: children
  }));
};
exports.AnalyticCardValue = AnalyticCardValue;
var AnalyticCardTrendContainer = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-analytic-card-trend-container", className)
  }, {
    children: children
  }));
};
exports.AnalyticCardTrendContainer = AnalyticCardTrendContainer;
var AnalyticCardTrend = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-analytic-card-trend", className)
  }, {
    children: children
  }));
};
exports.AnalyticCardTrend = AnalyticCardTrend;
var AnalyticCardTrendValue = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-analytic-card-trend-value", className)
  }, {
    children: children
  }));
};
exports.AnalyticCardTrendValue = AnalyticCardTrendValue;
var AnalyticCardNegativeTrendValue = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsxs)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-analytic-card-trend-value", "vsx-analytic-card-trend-negative", className)
  }, {
    children: [(0, jsx_runtime_1.jsx)(Icons_1.TrendDown, {}), children]
  }));
};
exports.AnalyticCardNegativeTrendValue = AnalyticCardNegativeTrendValue;
var AnalyticCardPositiveTrendValue = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsxs)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-analytic-card-trend-value", "vsx-analytic-card-trend-positive", className)
  }, {
    children: [(0, jsx_runtime_1.jsx)(Icons_1.TrendUp, {}), children]
  }));
};
exports.AnalyticCardPositiveTrendValue = AnalyticCardPositiveTrendValue;
var AnalyticCardTrendLabel = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-analytic-card-trend-label", className)
  }, {
    children: children
  }));
};
exports.AnalyticCardTrendLabel = AnalyticCardTrendLabel;
var AnalyticCardValueUnit = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsx)("span", __assign({}, restProps, {
    className: (0, classnames_1.default)("vsx-analytic-card-value-unit", className)
  }, {
    children: children
  }));
};
exports.AnalyticCardValueUnit = AnalyticCardValueUnit;
var ViewDetailButton = function (_a) {
  var _b = _a.label,
    label = _b === void 0 ? "View Details" : _b,
    restProps = __rest(_a, ["label"]);
  return (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({}, restProps, {
    type: "secondary",
    className: "vsx-analytic-card-view-detail-button"
  }, {
    children: label
  }));
};
exports.ViewDetailButton = ViewDetailButton;